// Phase 32 Plan 32-05 (RUNE-35) — Mulligan-active atom.
//
// Single nanostore boolean atom tracking whether the Lexical Mulligan selector
// overlay is currently mounted. MulliganSelector.tsx writes `true` in a mount
// effect and `false` in the cleanup. Future Pixi consumers (LetterCubeSprite
// pointerdown proxy) MAY subscribe to gate cell-tap behavior during Mulligan
// selection — Plan 32-05 ships the atom + writer; the read-side proxy is
// optional follow-up (the MulliganSelector itself owns its DOM cell-overlay
// pointer handling, so the atom is currently advisory/audit-only).
//
// Atom semantics:
//   - false (default) = overlay not mounted; normal field interaction.
//   - true            = MulliganSelector is mounted; consumers MAY adjust
//                       cell-tap routing (e.g. proxy pointerdown to a
//                       Mulligan event bus).
//
// Pattern matches Plan 32-03's `$cascadeFrontier` (single-atom store file,
// no setter helper — callers `.set(...)` directly).

import { atom } from 'nanostores'

/** True iff MulliganSelector overlay is currently mounted. */
export const $mulliganActive = atom<boolean>(false)
